var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalMainStLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 64,
    viewBox: "0 0 79 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3684 23.2188C14.5928 23.2188 15.1834 22.4509 15.1834 21.0439V13.1407C15.1834 11.7369 14.5928 10.9664 13.3467 10.9664H11.51V23.2188H13.3684ZM13.3907 9.4082C15.7727 9.4082 16.8664 10.8588 16.8664 13.2304V20.9798C16.8664 23.3303 15.7733 24.779 13.3907 24.779H9.80469V9.4082H13.3907Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4553 9.4082H18.75V24.7777H20.4553V9.4082Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4423 13.1196V14.4376H27.825V13.0318C27.825 11.6497 27.2784 10.8152 26.0316 10.8152C24.8072 10.8152 24.2383 11.6497 24.2383 13.0318V21.1572C24.2383 22.5399 24.8072 23.3751 26.0316 23.3751C27.2778 23.3751 27.825 22.5399 27.825 21.1572V18.0818H26.2504V16.5466H29.4423V21.0695C29.4423 23.3962 28.3492 24.9333 25.9876 24.9333C23.6484 24.9333 22.5547 23.3962 22.5547 21.0695V13.1215C22.5547 10.7935 23.6484 9.2583 25.9876 9.2583C28.3486 9.25574 29.4423 10.7915 29.4423 13.1196Z",
    fill: "#8F8F8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.745 9.4082H32.0391V24.7777H33.745V9.4082Z",
    fill: "#8F8F8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0779 24.7777V10.9671H35.2578V9.4082H42.6039V10.9671H39.7832V24.7777H38.0779Z",
    fill: "#8F8F8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7426 20.2106H48.1539L46.4269 11.3404L44.7426 20.2106ZM44.5239 21.6818L43.9333 24.7777H42.3594L45.2892 9.4082H47.7604L50.6902 24.7777H48.9848L48.3949 21.6818H44.5239Z",
    fill: "#8F8F8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4609 24.7777V9.4082H54.1663V23.2188H58.5392V24.7777H52.4609Z",
    fill: "#8F8F8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4437 50.1018H13.8047L11.2678 37.8718V50.1229H9.78125V34.7534H12.1645L14.6791 47.0283L17.1057 34.7534H19.4889V50.1229H17.871V37.7616L15.4437 50.1018Z",
    fill: "#8F8F8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7888 45.5571H26.2001L24.4731 36.6856L22.7888 45.5571ZM22.5707 47.0283L21.9802 50.1229H20.4062L23.336 34.7534H25.8066L28.7364 50.1229H27.0311L26.4412 47.0283H22.5707Z",
    fill: "#8F8F8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7366 34.7534H30.0312V50.1229H31.7366V34.7534Z",
    fill: "#8F8F8F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.929 50.1229H34.3984V34.7534H36.5629L40.1049 45.8639V34.7534H41.6132V50.1229H39.8422L35.929 37.6956V50.1229Z",
    fill: "#8F8F8F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.254 38.4438V38.8601H52.636V38.3547C52.636 36.9714 52.1124 36.1593 50.888 36.1593C49.6642 36.1593 49.1393 36.9714 49.1393 38.3336C49.1393 41.7799 54.2776 42.1097 54.2776 46.4353C54.2776 48.762 53.1628 50.2767 50.8236 50.2767C48.4837 50.2767 47.3906 48.762 47.3906 46.4353V45.5572H48.9869V46.523C48.9869 47.9064 49.5551 48.7185 50.7796 48.7185C52.004 48.7185 52.5729 47.9064 52.5729 46.523C52.5729 43.0979 47.457 42.7681 47.457 38.4438C47.457 36.0728 48.5507 34.6011 50.8453 34.6011C53.1615 34.6011 54.254 36.1157 54.254 38.4438Z",
    fill: "#8F8F8F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9685 50.1229V36.3136H55.1484V34.7534H62.4939V36.3136H59.6738V50.1229H57.9685Z",
    fill: "#8F8F8F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.374 47.9941H62.7344V50.1243H64.374V47.9941Z",
    fill: "#8F8F8F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7814 54.7447H9.76562V53.0718H66.7814C67.2617 53.0718 67.652 52.6805 67.652 52.1976L67.666 32.1324C67.666 31.6507 67.2763 31.2581 66.7955 31.2581H9.78093V29.5859H66.7955C68.194 29.5859 69.333 30.7291 69.333 32.1343L69.3177 52.1995C69.3177 53.6015 68.18 54.7447 66.7814 54.7447Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMainStLogo);
export default __webpack_public_path__ + "static/media/DigitalMainStLogo.89ba16fea0969aa2d2c81c52a2e82f06.svg";
export { ForwardRef as ReactComponent };